module.exports = __webpack_public_path__ + "img/2b.f25e4208.png";